// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanVersionPublishRun.yaml
// Generated: 2026-07-16T11:30:09.441Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePlanVersionPublishRun, UpdatePlanVersionPublishRun, PlanVersionPublishRun } from '@/types/finance/PlanVersionPublishRun';

/**
 * PlanVersionPublishRun Service
 * CRUD operations for PlanVersionPublishRun via the ABP API.
 */
export const planVersionPublishRunService = new EntityService<PlanVersionPublishRun, CreatePlanVersionPublishRun, UpdatePlanVersionPublishRun>(
  '/api/finance/planversionpublishrun',
  'PlanVersionPublishRun',
);
